<template>
    <div class="unit-introduction">
        <a-breadcrumb separator=">">
            <a-breadcrumb-item>
                <router-link to="/home">
                    <img src="../../assets/home/icon-home.svg" style="margin: 0 4px 4px 0" />首页
                </router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>单位介绍</a-breadcrumb-item>
        </a-breadcrumb>

        <div class="unit-introduction-body">
            <submenu-tabs title="单位介绍" :tabs="leftTab" @changeTab="tabChanged" propActive="公司简介" />
            <a-spin :spinning="loading">
                <div class="right-content">
                    <div class="subtitle">{{ currentSubtitle }}</div>
                    <div class="company-intro" v-html="currentContent"></div>
                    <div class="map-container" v-if="showMap">
                        <div id="map-container" style="width: 100%; height: 400px"></div>
                        <div class="map-address">
                            <a-icon type="environment" />
                            地址：{{ companyAddress }}
                        </div>
                    </div>
                </div>
            </a-spin>
        </div>
    </div>
</template>

<script>
import SubmenuTabs from '../../components/submenu-tabs.vue';
import AMapLoader from '@amap/amap-jsapi-loader';
import { queryUnitIntroduction, queryUnitIntroductionList, queryUnitIntroductionDetail } from '../../common/api';

export default {
    components: {
        SubmenuTabs
    },
    data() {
        return {
            currentSubtitle: '公司简介',
            leftTab: [],
            loading: false,
            currentContent: '',
            showMap: false, // 控制地图显示
            companyAddress: '郑州市国家高新技术产业开发区翠竹街6号', // 公司地址
            map: null, // 地图实例
            marker: null // 地图标记
        };
    },
    async created() {
        await this.getTab();
        await this.getContentDetail();
    },
    methods: {
        async tabChanged(tab) {
            this.currentSubtitle = tab.name;
            await this.getContentDetail();
            console.log('123');
            this.showMap = tab.name === '联系方式'; // 只在"联系方式"tab显示地图
            if (this.showMap && !this.map) {
                this.initMap();
            }
        },
        initMap() {
            AMapLoader.load({
                key: 'f55e8e1ce52aed96954203b33681e980', // 申请的高德地图开发者Key
                version: '2.0', // SDK版本
                plugins: ['AMap.Geocoder', 'AMap.Marker'] // 需要使用的插件
            })
                .then(AMap => {
                    this.map = new AMap.Map('map-container', {
                        zoom: 15, // 缩放级别
                        center: [113.56412, 34.81736], // 中心点坐标
                        viewMode: '2D' // 使用2D视图
                    });

                    // 添加标记
                    this.marker = new AMap.Marker({
                        position: [113.56412, 34.81736], // 标记位置
                        map: this.map
                    });

                    // 可选：信息窗口
                    const infoWindow = new AMap.InfoWindow({
                        content: '<div class="info-window">' + this.companyAddress + '</div>',
                        offset: new AMap.Pixel(0, -30)
                    });

                    this.marker.on('click', () => {
                        infoWindow.open(this.map, this.marker.getPosition());
                    });

                    this.showMap = true;
                })
                .catch(e => {
                    console.error('地图加载失败:', e);
                });
        },
        async getTab() {
            const res = await queryUnitIntroductionList();
            this.leftTab = res.data.map(item => {
                return {
                    ...item,
                    name: item.codename
                };
            });
        },

        async getContentDetail() {
            this.loading = true;
            const res = await queryUnitIntroduction({
                n: 1,
                s: 10,
                f: { introductionType_SEQ: this.currentSubtitle }
            });
            const id = res.data.rows.length ? res.data.rows[0].id : '0';
            const data = await queryUnitIntroductionDetail(id);
            this.currentContent = data.data.contentList[0].content;
            this.loading = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.unit-introduction {
    width: 1200px;
    padding-bottom: 78px;

    &-body {
        display: flex;
        align-items: flex-start;

        .ant-spin-nested-loading {
            flex: 1;
            width: 0px;
        }

        .right-content {
            width: 100%;
            margin-left: 16px;
            background: #ffffff;
            border-radius: 4px;
            padding: 16px 24px;
            overflow: hidden;

            .subtitle {
                height: 48px;
                font-size: 24px;
                font-weight: 600;
                letter-spacing: 0;
                color: #005299;
                background: url(../../assets/test-service/split.png) bottom no-repeat;
            }

            .company-intro {
                padding: 16px 0 128px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #1a1a1a;
                line-height: 28px;
            }
        }
    }
}

.map-container {
    margin-top: 30px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    overflow: hidden;
}

.map-address {
    padding: 12px;
    background: #f5f5f5;
    font-size: 14px;
    color: #666;
}

.info-window {
    padding: 8px;
    font-size: 12px;
}
</style>
